import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { PosMicrosIntegrationServiceTime } from '@mews-commander/data-access';
import { getDefaults, LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Card, CardContent, IconButton, IconName, Typography, Title, Stack } from '@optimus-web/core';
import { FieldNames } from '../fieldNames';
import { XmlPosOutletFormSchema } from '../microsOutlets/formProps';
import { ServingtimeMappingForm } from './ServingtimeMappingForm';
import { serviceTimeFormSchema } from './formProps';

export const ServingtimeMappingsList = () => {
    const { setValue } = useFormContext<XmlPosOutletFormSchema>();
    const { fields, append, remove } = useFieldArray<XmlPosOutletFormSchema, 'serviceTimes'>({
        name: FieldNames.serviceTimes,
    });

    const servingTimeMappingDefaultValues: PosMicrosIntegrationServiceTime = getDefaults(serviceTimeFormSchema);

    useEffect(() => {
        if (fields.length === 0) return;
        const defaultServiceTimeIndex = fields.findIndex((serviceTimes) => serviceTimes?.isDefault);
        if (defaultServiceTimeIndex < 0) {
            /** This sets the first default value to 'checked' as at least one default value should be checked */
            setValue(`${FieldNames.serviceTimes}.${0}.${FieldNames.isDefault}`, true);
        }
    }, [fields, setValue]);

    return (
        <Card title={TextKey.PosServingTimes}>
            <CardContent padding="200">
                <Stack alignment="start" distribution="space-between">
                    <Title level={2}>Serving Time Mappings</Title>
                    <Typography textStyle="bodyMediumStrong" as="div">
                        <LocalizedText
                            textKey={TextKey.PaymentMappingAddedItems}
                            substitutes={{ count: fields.length || 0 }}
                        />
                    </Typography>
                </Stack>
            </CardContent>
            <CardContent padding="200">
                <Stack vertical spacing="300">
                    {fields.map((field, index) => (
                        <Card key={field.id} padding="200">
                            <CardContent>
                                <Stack alignment="center" distribution="space-between">
                                    <ServingtimeMappingForm key={field.id} index={index} />
                                    <IconButton
                                        icon={IconName.Delete}
                                        type="button"
                                        variant="ghost"
                                        iconSize="small"
                                        onClick={() => {
                                            remove(index);
                                        }}
                                    />
                                </Stack>
                            </CardContent>
                        </Card>
                    ))}
                    <Stack alignment="start">
                        <Button
                            variant="tertiary"
                            icon={IconName.Add}
                            onClick={() => {
                                append(servingTimeMappingDefaultValues);
                            }}
                            type="button"
                        >
                            {lt('PosAddServingTime')}
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
};
